import React, { useEffect, useState } from 'react';
import api from '../../../store/api-service'
import Form from 'react-bootstrap/Form';
import { notify } from '../../../store/notification';
import IUIPdfView from '../../pdf-helper/IUIPdfView';

const IUIPictureUpload = (props) => {
    const schema = props?.schema;
    const shape = props?.shape;
    const module = props?.module;
    const [file, setFile] = useState([]);
    const [fileType, setFileType] = useState(null);
    const [baseFilter, setBaseFilter] = useState({});
    const [parentData, setParentData] = useState([]);
    const fileRef = React.createRef()
    const cardBodyStyle = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '300px',
        overflow: 'hidden',
        position: 'relative'
    };

    const fetchBase64 = async (fileName, fileModule) => {
        const response = await api.getBase64({ module: fileModule, file: fileName });
        return response?.data;
    }

    useEffect(() => {
        async function fetchData() {
            // Prepare the filter object based on schema
            const newBaseFilter = {
                name: schema?.filter,
                value: schema?.value,
                // operator: 'likelihood' // Default value is equal
            };

            setBaseFilter(newBaseFilter);  // Update the base filter state

            // Define pageOptions based on schema type
            let pageOptions = { recordPerPage: 0 };
            if (schema?.type === "lookup-filter") {
                pageOptions = {
                    ...pageOptions,
                    searchCondition: newBaseFilter,
                };
            }

            if (schema) {
                const response = await api.getData({ module: schema?.module, options: pageOptions });
                setParentData(response?.data?.items);
            }
        }

        fetchData();
    }, [schema?.filter, schema?.value, schema?.module, schema?.type]);

    useEffect(() => {
        async function fetchPictureData() {
            try {
                // if (file.length > 0) return;

                const parent = parentData?.find(data => data?.id === parseInt(props?.parentId));

                if (parent) {
                    const fileName = parent[schema?.relationKey];
                    const fileType = parent[schema?.relationKey]?.split(".")[1];

                    const base64Output = await fetchBase64(fileName, schema?.module);
                    const rawData = (fileType === "pdf") ? `data:application/pdf;base64,${base64Output?.base64}` : `data:image/${fileType};base64,${base64Output?.base64}`;

                    setFile(rawData);
                    props.onChange({
                        target: {
                            id: props?.id,
                            value: rawData,
                        },
                        preventDefault: () => { },
                    });
                }
            } catch (error) {
                notify("error", "Error loading file!");
            }
        }

        if (schema && props?.parentId) {
            fetchPictureData();
        }
    }, [props?.parentId, schema]);

    useEffect(() => {
        const setValue = async (val) => {
            if (val && val?.length > 0) {
                if (!val?.includes("base64")) {
                    
                    let type = val?.split('.')[1];
                    (type === "pdf") ? setFileType("pdf") : setFileType("image");

                    const base64Output = await fetchBase64(val, module);
                    const rawData = (type === "pdf") ? `data:application/pdf;base64,${base64Output?.base64}` : `data:image/${type};base64,${base64Output?.base64}`;

                    setFile(rawData);
                }
                else {
                    
                    let type = val?.split(';')[0];
                    (type === "data:application/pdf") ? setFileType("pdf") : setFileType("image");


                    setFile(val);
                }
            }
        }

        if (!props?.value) return;

        setValue(props?.value);
    }, [props?.value, module]);

    const handleChange = async (e) => {
        e.preventDefault();
        const selectedFile = e.target.files[0];
        if (!selectedFile) return;

        const imageContent = await convertBase64(selectedFile);
        setFile(imageContent);
        const type = selectedFile?.type;

        if (type === "image/png" || type === "image/jpeg") {
            setFileType("image");
        } else if (type === "application/pdf") {
            setFileType("pdf");
        } else {
            notify("error", "Unsupported file type!");
            setFileType(null);
            setFile(null);
        }

        const event = { target: { id: e.target.id, value: imageContent }, preventDefault: function () { } }

        if (props.onChange) {
            props.onChange(event);
        }

    }

    const triggerClick = (e) => {
        e.preventDefault();
        fileRef.current.click()
    }

    const convertBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file)
            fileReader.onload = () => {
                resolve(fileReader.result);
            }
            fileReader.onerror = (error) => {
                reject(error);
            }
        })
    }

    return (
        <>
            {
                (shape === "circle") && (
                    <div className="card position-relative" style={{ width: "10rem", height: "10rem", margin: "auto", borderRadius: "150px" }}>
                        <div className={`card-body form-control ${props.className}`} style={cardBodyStyle}>
                            <button className="btn top-0 end-0" onClick={triggerClick}>
                                {/* <i className="metismenu-icon fa-solid fa-cogs"></i> */}
                                {
                                    (file.length > 0) && (fileType === "image") && <img src={file} style={{ width: "10rem", height: "10rem", margin: "auto", borderRadius: "150px" }} title={props?.placeholder} alt={props?.placeholder} />
                                }
                                {
                                    (file.length === 0) && <span className="profile-pic-upload-text">
                                        <i className="fa-solid fa-cloud-arrow-up" title="Upload File"></i> {`Upload ${props?.text}`}
                                    </span>
                                }
                            </button>


                            <Form.Control
                                className='d-none'
                                id={props?.id}
                                type="file"
                                onChange={handleChange}
                                disabled={props.readonly || false}
                                ref={fileRef}
                                accept="image/gif, image/jpeg, image/png"
                            ></Form.Control>
                        </div>
                    </div>
                )
            }
            {
                (shape === "rect") && (
                    <>
                        {
                            (file && fileType !== "pdf") && (
                                <div className="card position-relative" style={{ width: "50rem", height: "30rem", margin: "auto" }}>
                                    <div className={`card-body form-control ${props.className}`} style={cardBodyStyle}>
                                        <button className="btn top-0 end-0 btn-info" onClick={triggerClick}>
                                            {/* <i className="metismenu-icon fa-solid fa-cogs"></i> */}
                                            {
                                                (file.length > 0) && (fileType === "image") && <img src={file} style={{ width: "50rem", height: "30rem", margin: "auto" }} title={props?.placeholder} alt={props?.placeholder} />
                                            }
                                            {
                                                (file.length === 0) && <span className="profile-pic-upload-text">
                                                    <i className="fa-solid fa-cloud-arrow-up" title="Upload Image"></i> {`Upload ${props?.text}`}
                                                </span>
                                            }
                                        </button>


                                        <Form.Control
                                            className='d-none'
                                            id={props?.id}
                                            type="file"
                                            onChange={handleChange}
                                            disabled={props.readonly || false}
                                            ref={fileRef}
                                            accept="image/gif, image/jpeg, image/png, application/pdf"
                                        ></Form.Control>
                                    </div>
                                </div>
                            )
                        }
                        {
                            (file.length > 0) && (fileType === "pdf") && (
                                <>
                                    <Form.Control
                                        className={props.readonly ? 'd-none' : 'mt-2'}
                                        id={props?.id}
                                        type="file"
                                        onChange={handleChange}
                                        disabled={props.readonly || false}
                                        ref={fileRef}
                                        accept="image/gif, image/jpeg, image/png, application/pdf"
                                    ></Form.Control>
                                    <IUIPdfView file={file} displayToolbar={false} height={100} />
                                </>
                            )
                        }
                        <p className='text-center mt-2'>Supported file types: .jpg, .png, .pdf</p>
                    </>
                )
            }
        </>
    );
}


export default IUIPictureUpload